import { getClubTimezone } from '@jupi/ui'

// The club's calendar day (YYYY-MM-DD) an instant falls on: the day the
// airfield sees, whatever timezone the browser is in.
export function clubDay(instant: string): string {
  return new Intl.DateTimeFormat('en-CA', {
    timeZone: getClubTimezone(),
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(new Date(instant))
}

// ISO week number of a YYYY-MM-DD date.
export function isoWeek(date: string): number {
  const [y, m, d] = date.split('-').map(Number) as [number, number, number]
  const target = new Date(Date.UTC(y, m - 1, d))
  const day = target.getUTCDay() || 7
  target.setUTCDate(target.getUTCDate() + 4 - day)
  const yearStart = Date.UTC(target.getUTCFullYear(), 0, 1)
  return Math.ceil(((target.getTime() - yearStart) / 86_400_000 + 1) / 7)
}
